import { z } from "zod/v4";
import { isValidEmail } from "../utils/isValidEmail.js";
// Normalizes email input by trimming string values and converting null, undefined, and empty strings into undefined
function normalizeEmailInputToOptionalString(input) {
    if (input === null || input === undefined) {
        return undefined;
    }
    if (typeof input === "string") {
        const trimmedString = input.trim();
        return trimmedString === "" ? undefined : trimmedString;
    }
    return input;
}
// Validates that a string value is a valid email address by using the existing isValidEmail helper function
const EmailStringValidationSchema = z.string().superRefine((email, context) => {
    const validationResult = isValidEmail(email);
    if (validationResult !== true) {
        context.addIssue({
            code: "custom",
            message: validationResult,
        });
    }
});
// Defines an optional email field that normalizes the input value and only validates the email format when a value is present
export const OptionalEmailSchema = z
    .string()
    .email()
    .optional()
    .or(z.literal(""))
    .or(z.null())
    .or(z.undefined());
// Defines a required email field that normalizes the input value and requires a valid email address to be provided
export const RequiredEmailSchema = z.preprocess(normalizeEmailInputToOptionalString, z
    .string({
    error: (issue) => issue.input === undefined ? "E-post er påkrevd." : "Ugyldig e-post.",
})
    .pipe(EmailStringValidationSchema));
